import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'discount'
})
export class DiscountPipe implements PipeTransform {

  transform(price: number, discount: number): any {
    let discountPrice = price;
    if (discount) {
        discountPrice = (((100 + discount) / 100) * price);
        price = price - discountPrice;
    }

    return price.toFixed(2);
  }

}
